export default "__VITE_ASSET__CE$xm1VZ__"